/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, March 22nd 2022, 8:03:15 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";

// Hook to check if a component has mounted. Useful when we may want to avoid running an effect on the initial render.
// Kudos to https://stackoverflow.com/questions/53179075/with-useeffect-how-can-i-skip-applying-an-effect-upon-the-initial-render

export const useDidMount = () => {
  // Always intiate to false, since this initialization happens on every render of the component.
  // Ref remains for the lifecycle of the component until re-render
  // We do not want it to be stateful, since a stateful value would cause reRenders if used in a dependency list
  const didMountRef = React.useRef(false);

  React.useEffect(() => {
    didMountRef.current = true;
  }, []);

  return didMountRef.current;
};
